// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3ALb7","footerContainer":"Footer_footerContainer__35C60"};